<p-table
	#dt
	styleClass="p-datatable-responsive-demo"
	[value]="cardPool"
	dataKey="cardNumber"
	[paginator]="cardPool && cardPool.length > 10"
	[rows]="10"
	[showCurrentPageReport]="true"
	currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
	[rowsPerPageOptions]="[10, 25, 50]"
	[globalFilterFields]="['name', 'displayName', 'canvasKey']"
>
	<ng-template pTemplate="caption">
		<div class="table-header d-flex">
			<div class="d-flex flex-fill me-2">
				<span class="p-float-label p-input-icon-left m-2 w-100">
					<i class="pi pi-search"></i>
					<input
						pInputText
						class="w-100"
						id="globalSearch"
						name="globalSearch"
						style="width: 100%"
						type="text"
						(input)="dt.filterGlobal($event.target.value, 'contains')"
					/>
					<label for="globalSearch">Search by promo code</label>
				</span>
				<p-splitButton
					label="Add by range"
					(onClick)="addType = 'range'"
					[model]="multiButton"
					styleClass="p-button-secondary p-button-raised"
				></p-splitButton>
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="header" #header>
		<tr>
			<th pSortableColumn="cardNumber">
				Card Number
				<p-sortIcon field="cardNumber"></p-sortIcon>
			</th>
			<th pSortableColumn="activated">
				Activated
				<p-sortIcon field="activated"></p-sortIcon>
			</th>
			<th pSortableColumn="created">
				Created
				<p-sortIcon field="created"></p-sortIcon>
			</th>
			<th pSortableColumn="activatedDateTime">
				Activated Date
				<p-sortIcon field="activatedDateTime"></p-sortIcon>
			</th>
			<th></th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" #body let-rec let-idx="index">
		<tr>
			<td>
				{{ rec.cardNumber }}
			</td>
			<td>
				<span *ngIf="rec.activated">
					<fa-icon [icon]="['far', 'check']"></fa-icon>
				</span>
			</td>
			<td>
				{{ moment(rec.created).format("L") }}
			</td>
			<td>
				<span *ngIf="rec.activatedDateTime">
					{{ moment(rec.activatedDateTime).format("L") }}
				</span>
			</td>
			<td style="text-align: right">
				<p-button pRipple styleClass="p-button-raised p-button-danger m-2" (click)="eGiftCardPoolDelete(rec.cardNumber)">
					<ng-template pTemplate="content">
						<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
					</ng-template>
				</p-button>
			</td>
		</tr>
	</ng-template>
</p-table>

<p-dialog header="Add to Card Pool" [(visible)]="addType" [closable]="false" [closeOnEscape]="false" [baseZIndex]="10000">
	<div style="width: 500px; height: 600px">
		<div *ngIf="addType === 'range'">
			<div class="p-grid">
				<div class="p-col">
					<p-inputNumber
						placeholder="Starting Number"
						name="cardNumber"
						[(ngModel)]="newStartingNumber"
						max="99999999999999999999"
						[useGrouping]="false"
						styleClass="w-100"
					></p-inputNumber>
				</div>
				<div class="p-col">
					<p-inputNumber
						placeholder="End Number"
						name="cardNumber"
						[(ngModel)]="newEndingNumber"
						max="99999999999999999999"
						[useGrouping]="false"
						styleClass="w-100"
					></p-inputNumber>
				</div>
			</div>
		</div>
		<div *ngIf="addType === 'array'">
			<div class="p-grid">
				<div class="p-col">
					<p-inputNumber
						placeholder="Card Number"
						name="cardNumber"
						[(ngModel)]="newCardNumber"
						max="99999999999999999999"
						[useGrouping]="false"
						styleClass="w-75"
					></p-inputNumber>
					<fa-icon [icon]="['far', 'plus']" size="lg" class="ms-1" (click)="addNewCardToPool(newCardNumber)"></fa-icon>
				</div>
				<div class="p-col">
					<div *ngFor="let rec of newCardPool; let idx = index" class="d-flex flex-column">
						<div class="p-grid">
							<div class="col-9">
								{{ rec }}
							</div>
							<div class="col-3">
								<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1" (click)="newCardPool.splice(idx, 1)"></fa-icon>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<p-footer>
		<div class="d-flex justify-content-end">
			<p-button
				pRipple
				styleClass=" p-button-raised p-button-danger m-2"
				(click)="newCardPool = []; addType = undefined; newStartingNumber = undefined; newEndingNumber = undefined"
			>
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'window-close']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
			<p-button
				*ngIf="addType === 'range'"
				pRipple
				styleClass=" p-button-raised p-button-success m-2"
				(click)="eGiftCardPoolPostRange(newStartingNumber, newEndingNumber)"
				[disabled]="!newStartingNumber || !newEndingNumber || newStartingNumber > newEndingNumber"
			>
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
			<p-button
				*ngIf="addType === 'array'"
				pRipple
				styleClass=" p-button-raised p-button-success m-2"
				(click)="eGiftCardPoolPostArray()"
				[disabled]="!newCardPool || newCardPool.length === 0"
			>
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'save']" size="lg" class="ms-1"></fa-icon>
				</ng-template>
			</p-button>
		</div>
	</p-footer>
</p-dialog>
<input type="file" name="importFileTwo" id="importFileTwo" (change)="importFileUpload($event)" accept=".txt,.csv" hidden />
